var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu__container__wrapper sticky-on-top",attrs:{"id":"menu__container__wrapper"}},[_c('div',{staticClass:"menu__container__wrapper-content__menu"},_vm._l((_vm.menuHeader),function(item,index){return _c('client-menu-item',{key:index,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }